(function () {
  var roots = document.querySelectorAll('.tgs');
  if (!roots.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reveals = [].slice.call(document.querySelectorAll('.tgs-rv'));

  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(el); });
    [].forEach.call(roots, function (r) { r.classList.add('tgs-ready'); });
  }
  if (reduce) return;

  if (fine) {
    [].forEach.call(document.querySelectorAll('.tgs-mag'), function (b) {
      b.addEventListener('pointermove', function (ev) {
        var r = b.getBoundingClientRect();
        var dx = (ev.clientX - r.left - r.width / 2) / r.width;
        var dy = (ev.clientY - r.top - r.height / 2) / r.height;
        b.style.transform = 'translate(' + dx * 8 + 'px,' + dy * 6 + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });

    [].forEach.call(document.querySelectorAll('.tgs-tilt'), function (c) {
      var raf = null;
      c.addEventListener('pointermove', function (ev) {
        var r = c.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width, py = (ev.clientY - r.top) / r.height;
        if (raf) return;
        raf = requestAnimationFrame(function () {
          c.style.transform = 'perspective(900px) rotateX(' + (py - 0.5) * -7 + 'deg) rotateY(' + (px - 0.5) * 9 + 'deg) translateY(-4px)';
          c.style.setProperty('--mx', px * 100 + '%');
          c.style.setProperty('--my', py * 100 + '%');
          raf = null;
        });
      });
      c.addEventListener('pointerleave', function () {
        c.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
        c.style.transform = '';
        setTimeout(function () { c.style.transition = ''; }, 600);
      });
    });

    var hero = document.querySelector('[data-tgs-hero]');
    if (hero) {
      var layers = [].slice.call(hero.querySelectorAll('.tgs-lyr'));
      var hx = 0, hy = 0, tx = 0, ty = 0, running = false;
      var step = function () {
        hx += (tx - hx) * 0.06; hy += (ty - hy) * 0.06;
        layers.forEach(function (l) {
          var d = parseFloat(l.getAttribute('data-depth')) || 10;
          l.style.transform = 'translate3d(' + hx * d + 'px,' + hy * d + 'px,0)';
        });
        if (Math.abs(tx - hx) > 0.001 || Math.abs(ty - hy) > 0.001) requestAnimationFrame(step); else running = false;
      };
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        tx = (ev.clientX - r.left) / r.width - 0.5; ty = (ev.clientY - r.top) / r.height - 0.5;
        if (!running) { running = true; requestAnimationFrame(step); }
      });
    }
  }

  var plx = document.querySelector('[data-tgs-plx]');
  if (plx) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var r = plx.parentElement.getBoundingClientRect(), vh = window.innerHeight;
        if (r.top < vh && r.bottom > 0) plx.style.transform = 'translateY(' + ((r.top + r.height / 2 - vh / 2) / vh) * -34 + 'px)';
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
